import { Box, Grid, Stack, Typography } from '@mui/material';
import facebookIcon from 'assets/images/facebook-f.svg';
import youtubeIcon from 'assets/images/youtube.svg';
import { VbiLogo } from 'components/Elements/Buttons/VbiLogo';

const FACEBOOK_HREF = 'https://www.facebook.com/people/The-Virginia-Neurological-Birth-Related-Injury-Compensation-Program/61587880746988/';
const YOUTUBE_HREF = 'https://www.youtube.com/@VirginiaBirthInjuryProgram';

const addressColor = '#eef4ff';
const socialHoverIcon = '#597897';

const SocialIcon: React.FC<{ src: string }> = ({ src }) => (
  <Box
    aria-hidden
    sx={{
      display: 'block',
      width: 16,
      height: 16,
      bgcolor: 'currentColor',
      mask: `url(${src}) center / contain no-repeat`,
      WebkitMask: `url(${src}) center / contain no-repeat`,
    }}
  />
);

const addressTextSx = {
  color: addressColor,
  mb: '23px',
  lineHeight: 1.72,
  letterSpacing: '0.015em',
  fontSize: 16,
  fontWeight: 400,
} as const;

const socialChipSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 16,
  p: '8px',
  boxSizing: 'content-box',
  bgcolor: 'white',
  color: 'primary.main',
  borderRadius: '4px',
  lineHeight: 1,
  textDecoration: 'none',
  '&:hover': {
    bgcolor: 'white',
    color: socialHoverIcon,
  },
} as const;

export const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        pt: '40px',
        px: '30px',
        display: 'flex',
        justifyContent: 'center',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 1664 }}>
        <Box
          sx={{
            bgcolor: 'primary.main',
            borderRadius: '50px 50px 0 0',
            pt: '4%',
            px: '4%',
            pb: 2,
            mx: { xs: 0, md: '1.92%' },
            boxSizing: 'border-box',
          }}
        >
          <Grid container columnSpacing={{ xs: 1, md: 4 }} rowSpacing={2} alignItems="flex-start">
            <Grid item xs={12} md={4} sx={{ marginBottom: '20px' }}>
              {/* Mirrors WP fusion-image-element --awb-max-width:350px + img-responsive */}
              <Box sx={{ width: '100%', maxWidth: 350 }}>
                <VbiLogo
                  variant="white"
                  sx={{
                    display: 'block',
                    width: '100%',
                    height: 'auto',
                    maxWidth: '100%',
                  }}
                />
              </Box>
              <Stack direction="row" spacing={1} sx={{ mt: '30px', ml: '40px' }}>
                <Box component="a" href={FACEBOOK_HREF} target="_blank" rel="noopener noreferrer" aria-label="facebook" sx={socialChipSx}>
                  <SocialIcon src={facebookIcon} />
                </Box>
                <Box component="a" href={YOUTUBE_HREF} target="_blank" rel="noopener noreferrer" aria-label="youtube" sx={socialChipSx}>
                  <SocialIcon src={youtubeIcon} />
                </Box>
              </Stack>
            </Grid>

            <Grid item md={4} sx={{ display: { xs: 'none', md: 'block' } }} />

            <Grid item xs={12} md={4} sx={{ marginBottom: '20px' }}>
              <Box sx={{ justifyContent: 'center', paddingLeft: { xs: '40px', md: 0 } }}>
                <Typography sx={addressTextSx}>
                  7501 Boulder View Drive, Suite 600
                  <br />
                  Richmond, VA 23225
                </Typography>
                <Typography sx={addressTextSx}>
                  p: (804) 330-2471
                  <br />
                  f: (804) 330-3054
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ paddingTop: '80px' }}>
            <Typography
              sx={{
                color: '#fff',
                fontSize: 14,
                ml: '20px',
                mt: 2,
                lineHeight: 1.72,
                letterSpacing: '0.015em',
              }}
            >
              ©2026 Virginia Birth-Related Neurological Injury Compensation Program | All Rights Reserved
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
